import { render } from "./FloatingBarPage.page.vue?vue&type=template&id=2023e5f1"
import script from "./FloatingBarPage.page.vue?vue&type=script&lang=js"
export * from "./FloatingBarPage.page.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ASIP-Sante/g1/shared/santefr/web/modules/custom/sante_vuejs/vue-core/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/etr/FloatingBarPage.page.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2023e5f1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2023e5f1', __exports__)) {
    console.log('reload')
    api.reload('2023e5f1', __exports__)
  }
  
  module.hot.accept("./FloatingBarPage.page.vue?vue&type=template&id=2023e5f1", () => {
    console.log('re-render')
    api.rerender('2023e5f1', render)
  })

}


export default __exports__